export const SUCCESS_THEME_LIST = "SUCCESS_THEME_LIST";
export const LOADING_THEME_LIST = "LOADING_THEME_LIST";
export const PREVIEW_DATA_SUCCESS = "PREVIEW_DATA_SUCCESS";
export const TAGGING_DATA_SUCCESS = "TAGGING_DATA_SUCCESS";
export const UPLOAD_PROGRESS = "UPLOAD_PROGRESS";
